import React from 'react';
import Anchor from '@atlaskit/primitives/anchor';
import { fg } from '@atlassian/jira-feature-gating';
import type { Props } from './types';
import URLs from './urls';

function DocLink({ type: Tag = 'a', href, className, ariaLabel, children, tagRef }: Props) {
	return fg('jira-link-in-text-block-a11y-violations') ? (
		<Anchor href={href} ref={tagRef} target="_blank" aria-label={ariaLabel}>
			{children}
		</Anchor>
	) : (
		<Tag
			href={href}
			target="_blank"
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
			className={className}
			ref={tagRef}
			aria-label={ariaLabel}
		>
			{children}
		</Tag>
	);
}

DocLink.URLs = URLs;
export default DocLink;
